export const participantNameExtractor = (name: string) => {
    if (name?.includes('#')) {
        return name?.substring(0, name?.indexOf('#'));
    } else return name;
};
